import { createTranslations } from '@npco/common-utils-translations'

export const translations = createTranslations({
  heading: 'Description',
  noData: 'No description added yet',
  placeholder: 'Start typing...',
  successNotification: 'Description updated successfully.',
  errorNotification: 'Description could not be edited, please try again.',
})
